import constants from '@/app-configs/constants'

export default [
  {
    path: '/file-categories',
    name: 'file-categories',
    component: () => import('@/views/fileCategories/FileCategories.vue'),
    meta: {
      pageTitle: 'DEBTIA_FILE_CATEGORIES',
      breadcrumb: [
        {
          text: 'DEBTIA_FILE_CATEGORIES',
          active: true,
        },
      ],
      action: constants.action.permissionFileCategoryView,
      resource: constants.resource.fileCategories,
      companyOnly: true,
    },
  },
]
